/**
 * CPV-AI-01 · the drawer requests the CPV pages open (AssistantDrawer `request`). The intent words are the server's
 * closed vocabulary (engines/vocabulary/cpv_ai.py Intent); the ids are the page's own.
 */
export const INTENT = { BATCH_SUMMARY: 'BATCH_SUMMARY', SIGNAL_EXPLAIN: 'SIGNAL_EXPLAIN' };

/** "Explain this trend" on a parameter page: the parameter's recent batches, in its plan's product. */
export function explainTrendRequest(plan, itemId, name) {
  return {
    kind: 'ask', title: 'Explain this trend', intent: INTENT.BATCH_SUMMARY,
    question: `Explain the trend of ${name}.`,
    context: { product: plan?.product ?? undefined, parameter: itemId },
  };
}

/** "Summarise signal" on a signal page or a signals list row. */
export function summariseSignalRequest(signalId) {
  return { kind: 'signal', title: 'Signal summary', signal: signalId, context: {} };
}

/** What an investigation outline is of (the server's InvestigationSubject words, lower case for the drawer). */
export const SUBJECT = { SIGNAL: 'signal', INSIGHT: 'insight' };

/** "Investigate" on a signal page or in an insight drawer (AI-6): the outline of that record. */
export function investigateRequest(subject, id) {
  return { kind: 'investigate', title: 'Investigation outline', subject, id, context: {} };
}
